import { Modal } from 'react-bootstrap';
import { Lang } from '../../_types';
import { SuccessPopupStyles } from './SuccessPopup';

interface SuccessPopupProps {
  show: boolean;
  handleClose: () => void;
  lang?: Lang;
  error?: string;
}
const SuccessPopup = ({
  show = false,
  handleClose = () => {},
  lang = 'en',
  error = '',
}: SuccessPopupProps) => {
  return (
    <SuccessPopupStyles centered show={show} onHide={handleClose}>
      <Modal.Body>
        <div className="check-container">
          <img className="check-icon" src="images/check.png" alt="" />
        </div>
        <div className="inform-text">Success</div>
      </Modal.Body>
    </SuccessPopupStyles>
  );
};

export default SuccessPopup;
